import { hdiTicketWebsocketCommands } from '../../constants/hdiTicketWebsocketCommands';
import alertMessages from '../../intl/common/alertMessages';
import { errorAlert, warnAlert } from '../alertsActions';

export const loadBvmData = (vin) => (dispatch) => {
    dispatch({
        type: hdiTicketWebsocketCommands.HDI_BVM_DATA_PENDING,
        hdiWebsocket: true,
        command: hdiTicketWebsocketCommands.HDI_GET_BVM_DATA,
        payload: { vin },
    });
};

export const bvmDataTimeout = () => (dispatch) => {
    dispatch(errorAlert(alertMessages.BVM_LOAD_TIMEOUT));
};

export const notifyBvmError = (error) => (dispatch) => {
    const code = typeof error === 'string' ? error : (error && error.errCode);
    const msg = alertMessages[code] || alertMessages.BVM_LOAD_ERROR;
    dispatch(errorAlert(msg));
};

export const notifyBvmWarning = (warning) => (dispatch) => {
    const code = typeof warning === 'string' ? warning : (warning && warning.warnCode);
    const msg = alertMessages[code] || alertMessages.BVM_LOAD_ERROR;
    dispatch(warnAlert(msg));
};

